import React from 'react';
import { RaisedButton, FlatButton } from "material-ui";
import { connect } from 'react-redux';
import { SmallFlatButton } from '../../tc-ui/small-buttons';
import { openDialog as openDialogAction } from '../__storeFiles__/actions';

const queryString = require('query-string');

const Warning = props => {
  const {
    loggedInSession: { email: loggedInEmail },
    newUserInfo = {},
    viewAs,
    associateEmail,
    sameLoggedInType,
    wrongAccountType,
    hashToken,
    updateDialogProps,
    type,
    userId,
    ratesOrRequests,
    wrongAccountWarningText,
    assetOwnerEmail,
    country,
    openDialog,
  } = props;
  const { email: newUserEmail } = newUserInfo;
  const hasAccount = Boolean(userId);
  const companyTypeLabel = viewAs === 'Contractor' ? 'Buyer' : 'Supplier';
  const oppositeAccountType =  viewAs === 'Contractor' ? 'Supplier' : 'Buyer';
  if (!sameLoggedInType) {
    return (
      <div data-cy="warning-wrong-login-type">
        You are currently logged in as <b>{loggedInEmail}</b>, which is a {oppositeAccountType} account. {wrongAccountWarningText}
        <div style={{ width: '100%', marginTop: '24px' }}>
          How would you like to proceed?
        </div>
        <div
          className="flex-tc-sb"
          style={{ width: '100%', margin: 'auto', marginTop: '24px' }}
        >
          <FlatButton
            data-cy="createAccount"
            labelStyle={{ textTransform: 'none', top: '-2px' }}
            style={{ border: '1px solid #00bcd4' }}
            label={`Create A ${companyTypeLabel} Account`}
            secondary
            onTouchTap={() => {
              const defaultPayloadForSignUp = {
                type: 'signup',
                viewAs,
                country,
              };
              if (wrongAccountType) {
                openDialog({ ...defaultPayloadForSignUp, hashToken, preconfirmed: false, wrongAccountType });
              } else {
                openDialog({ ...defaultPayloadForSignUp, signupEmail: assetOwnerEmail, preconfirmed: true });
              }
            }}
          />
          <RaisedButton
            label={`Log In To A ${companyTypeLabel} Account`}
            style={{ border: '1px solid #00bcd4' }}
            labelStyle={{ textTransform: 'none' }}
            onTouchTap={() => updateDialogProps({ showwarning: false })}
            secondary
            data-cy="proceed-to-login"
          />
        </div>
      </div>
    );
  }
  if (associateEmail && !wrongAccountType) {
    return (
      <div data-cy="warning-for-no-account">
        <div style={{ width: '100%', marginBottom: '24px', marginTop: '8px' }}>
          You are currently logged in as <b>{loggedInEmail}</b>, would you like to add {associateEmail}, and the {ratesOrRequests} sent to that email, to your account?
        </div>
        <div
          className="flex-tc-sb"
          style={{ width: '100%', marginTop: '24px' }}
        >
          <RaisedButton
            data-cy="consolidate-and-associate-to-current"
            labelStyle={{ textTransform: 'none' }}
            label={`Yes, Add To Current Account`}
            secondary
            onTouchTap={() => window.location = `${window.location.protocol}//${window.location.host}/assets-consolidation/${hashToken}?${queryString.stringify({ associateEmail })}`}
          />
          <FlatButton
            label="Log In To A Different Account"
            style={{ border: '1px solid #00bcd4' }}
            labelStyle={{ textTransform: 'none' }}
            onTouchTap={() => updateDialogProps({ showwarning: false })} secondary data-cy="proceed-to-login"
          />
        </div>
      </div>
    );
  }
  return (
    <div data-cy="warning-for-wrong-account">
      <div style={{ width: '100%', marginBottom: '24px', marginTop: '8px' }}>
        <b>{assetOwnerEmail}</b> has a {oppositeAccountType} account. {wrongAccountWarningText}
        <div style={{ width: '100%', marginTop: '24px' }}>
          You are currently logged in as <b>{loggedInEmail}</b>, would you like to add the {ratesOrRequests} sent to that email, to this account?
        </div>
      </div>
      <div className="flex-tc-sb">
        <RaisedButton
          data-cy="consolidate-to-current"
          labelStyle={{ textTransform: 'none' }}
          label={`Yes, Add To Current Account`}
          secondary
          onTouchTap={() => window.location = `${window.location.protocol}//${window.location.host}/assets-consolidation/${hashToken}`}
        />
        <FlatButton
          label="Log In To A Different Account"
          style={{ border: '1px solid #00bcd4' }}
          labelStyle={{ textTransform: 'none' }}
          onTouchTap={() => updateDialogProps({ showwarning: false })} secondary data-cy="proceed-to-login"
        />
      </div>
    </div>
  );
  // return (
  //   <div
  //     data-cy="browser-loggedin-warning-for-createaccount-attempt"
  //     style={{ textAlign: 'center' }}
  //   >
  //     <FontIcon
  //       className={'tc-icon-paperplane'}
  //       color={'#27cfc3'}
  //       style={{ fontSize: '50px', marginBottom: '16px' }}
  //     />
  //     <div style={{ width: '100%', marginBottom: '24px', marginTop: '16px', fontSize: '15px' }}>
  //       Congratulations! We have created a new account for <b>{newUserEmail}</b>.
  //       <div style={{ fontSize: '12px', marginTop: '24px' }}>
  //         Please be informed that you are currently logged in as <b>{loggedInEmail}</b>, by clicking Continue, you will be logged out and we will log you into your new account.
  //       </div>
  //     </div>
  //     <div
  //       className="flex-tc-sb"
  //       style={{ width: '100%', marginTop: '24px' }}
  //     >
  //       <div/>
  //       <RaisedButton label="Continue" onTouchTap={props.autoLogin} secondary data-cy="autoLogin" />
  //     </div>
  //   </div>
  // );
};

export default connect(null, { openDialog: openDialogAction })(Warning);



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/dialog/warning.jsx